<my-label>
    <label for="{ props.ckey }" class="block text-sm/6 font-medium text-gray-900 w-full">{ props.label }</label>
</my-label>
